import { render } from "./ConsoGroupDetails.vue?vue&type=template&id=78ed159a&ts=true"
import script from "./ConsoGroupDetails.vue?vue&type=script&lang=ts"
export * from "./ConsoGroupDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__